// // import { lazy } from 'react';

// // // Lazy load components
// // const Dashboard               = lazy(() => import('../features/dashboard/Dashboard'));
// // const Login                   = lazy(() => import('../features/auth/pages/Login'));
// // const AdminList               = lazy(() => import('../features/admin-management/pages/AdminList'));
// // const CreateAdmin             = lazy(() => import('../features/admin-management/pages/CreateAdmin'));
// // const TournamentList          = lazy(() => import('../features/tournament-management/pages/TournamentList'));
// // const TournamentDetails       = lazy(() => import('../features/tournament-management/pages/TournamentDetails'));
// // const CreateTournament        = lazy(() => import('../features/tournament-management/pages/CreateTournament'));
// // const TournamentRegistrations = lazy(() => import('../features/tournament-management/pages/TournamentRegistrations'));
// // const ViewMatches             = lazy(() => import('../features/tournament-management/pages/ViewMatches'));
// // const ScheduleMatches         = lazy(() => import('../features/tournament-management/pages/ScheduleMatches'));
// // const GroupPlayers            = lazy(() => import('../features/tournament-management/pages/GroupPlayers'));
// // const CoachList               = lazy(() => import('../features/coach-management/pages/CoachList'));
// // const CourtList               = lazy(() => import('../features/court-management/pages/CourtList'));
// // const AddCourt                = lazy(() => import('../features/court-management/pages/AddCourt'));
// // const CourtRegistrations      = lazy(() => import('../features/court-management/pages/CourtRegistrations'));
// // const SportList               = lazy(() => import('../features/sport-management/pages/SportList'));
// // const CustomerList            = lazy(() => import('../features/user-management/pages/CustomerList'));
// // const AddSport                = lazy(() => import('../features/sport-management/pages/AddSport'));
// // const RefereeList             = lazy(() => import('../features/referee-management/pages/RefereeList'));
// // const RefereeSelectTournament = lazy(() => import('../features/live-score-update/RefereeSelectTournament')); 
// // const PaymentsList            = lazy(() => import('../features/payments/pages/PaymentsList'));
// // const RolesPermissions        = lazy(() => import('../features/roles-permissions/pages/RolesPermissions'));
// // const CommissionList          = lazy(() => import('../features/commission-management/CommissionList'));
// // const RoleList                = lazy(() => import('../features/roles-permissions/pages/RoleList'));
// // const UserList                = lazy(() => import('../features/roles-permissions/pages/UserList'));
// // const PlayerList              = lazy(()=> import('../features/players-management/playerlist') );


// // export const publicRoutes = [
// //     {
// //         path     : '/login',
// //         component: Login,
// //     },
// // ];


// // export const protectedRoutes = [

// //     // ── Dashboard ──────────────────────────────────────────────────────────
// //     {
// //         path     : '/',
// //         component: Dashboard,
// //         roles    : ['super-admin', 'admin'],
// //     },
// //     {
// //         path     : '/dashboard',
// //         component: Dashboard,
// //         roles    : ['super-admin', 'admin'],
// //     },

// //     // ── Admin Management ───────────────────────────────────────────────────
// //     {
// //         path     : '/admin-management',
// //         component: AdminList,
// //         roles    : ['super-admin'],
// //     },
// //     {
// //         path     : '/admin-management/create',
// //         component: CreateAdmin,
// //         roles    : ['super-admin'],
// //     },

// //     // ── Court Management ───────────────────────────────────────────────────
// //     {
// //         path     : '/court-management',
// //         component: CourtList,
// //         roles    : ['super-admin', 'admin'],
// //     },
// //     {
// //         path     : '/court-management/add',
// //         component: AddCourt,
// //         roles    : ['super-admin', 'admin'],
// //     },
// //     {
// //         path     : '/court-management/:id/registrations',
// //         component: CourtRegistrations,
// //         roles    : ['super-admin', 'admin'],
// //     },

// //     // ── Tournament Management ──────────────────────────────────────────────
// //     {
// //         path     : '/tournaments',
// //         component: TournamentList,
// //         roles    : ['super-admin', 'admin'],
// //     },
// //     {
// //         path     : '/tournaments/create',
// //         component: CreateTournament,
// //         roles    : ['super-admin', 'admin'],
// //     },
// //     {
// //         path     : '/tournaments/:id',
// //         component: TournamentDetails,
// //         roles    : ['super-admin', 'admin'],
// //     },
// //     {
// //         path     : '/tournaments/:id/registrations',
// //         component: TournamentRegistrations,
// //         roles    : ['super-admin', 'admin'],
// //     },
// //     {
// //         path     : '/tournaments/:id/matches',
// //         component: ViewMatches,
// //         roles    : ['super-admin', 'admin'],
// //     },
// //     {
// //         path     : '/tournaments/:id/schedule-matches',
// //         component: ScheduleMatches,
// //         roles    : ['super-admin', 'admin'],
// //     },
// //     {
// //         path     : '/tournaments/:id/group-players',
// //         component: GroupPlayers,
// //         roles    : ['super-admin', 'admin'],
// //     },

// //     // ── Sports Management ──────────────────────────────────────────────────
// //     {
// //         path     : '/sports-management',
// //         component: SportList,
// //         roles    : ['super-admin'],
// //     },
// //     {
// //         path     : '/sports-management/add',
// //         component: AddSport,
// //         roles    : ['super-admin'],
// //     },

// //     // ── Coach Management ───────────────────────────────────────────────────
// //     {
// //         path     : '/coach-management',
// //         component: CoachList,
// //         roles    : ['super-admin', 'admin'],
// //     },
// //     // ── Player Management ───────────────────────────────────────────────────
// //     {
// //         path     : '/player-management',
// //         component: PlayerList,
// //         roles    : ['super-admin', 'admin'],
// //     },

// //     // ── User Management ────────────────────────────────────────────────────
// //     {
// //         path     : '/user-management',
// //         component: CustomerList,
// //         roles    : ['super-admin', 'admin'],
// //     },

// //     // ── Referee Management (Admin view) ────────────────────────────────────
// //     {
// //         path     : '/referee-management',
// //         component: RefereeList,
// //         roles    : ['super-admin', 'admin'],
// //     },

// //     // ── Referee Portal (Referee role) ──────────────────────────────────────
// //     {
// //         path     : '/live-score-update',              // Select Tournament page ← NEW
// //         component: RefereeSelectTournament,
// //         roles    : ['referee','super-admin','admin'],
// //     },
    

// //     // ── Roles & Permissions ────────────────────────────────────────────────
// //     {
// //         path     : '/roles-permissions',
// //         component: RolesPermissions,
// //         roles    : ['super-admin'],
// //     },
// //     {
// //         path     : '/roles-list',
// //         component: RoleList,
// //         roles    : ['super-admin'],
// //     },
// //     {
// //         path     : '/user-list',
// //         component: UserList,
// //         roles    : ['super-admin'],
// //     },

// //     // ── Payments & Revenue ─────────────────────────────────────────────────
// //     {
// //         path     : '/payments-revenue',
// //         component: PaymentsList,
// //         roles    : ['super-admin'],
// //     },
// //     {
// //         path     : '/commmission-management',           // note: typo kept intentionally to match existing
// //         component: CommissionList,
// //         roles    : ['super-admin'],
// //     },

// // ];
// import { lazy } from 'react';

// // Lazy load components
// const Dashboard               = lazy(() => import('../features/dashboard/Dashboard'));
// const Login                   = lazy(() => import('../features/auth/pages/Login'));
// const AdminList               = lazy(() => import('../features/admin-management/pages/AdminList'));
// const CreateAdmin             = lazy(() => import('../features/admin-management/pages/CreateAdmin'));
// const TournamentList          = lazy(() => import('../features/tournament-management/pages/TournamentList'));
// const TournamentDetails       = lazy(() => import('../features/tournament-management/pages/TournamentDetails'));
// const CreateTournament        = lazy(() => import('../features/tournament-management/pages/CreateTournament'));
// const TournamentRegistrations = lazy(() => import('../features/tournament-management/pages/TournamentRegistrations'));
// const ViewMatches             = lazy(() => import('../features/tournament-management/pages/ViewMatches'));
// const ScheduleMatches         = lazy(() => import('../features/tournament-management/pages/ScheduleMatches'));
// const GroupPlayers            = lazy(() => import('../features/tournament-management/pages/GroupPlayers'));
// const CoachList               = lazy(() => import('../features/coach-management/pages/CoachList'));
// const CoachRegistration       = lazy(() => import('../features/coach-management/pages/CoachRegistration'));  // ← NEW
// const CourtList               = lazy(() => import('../features/court-management/pages/CourtList'));
// const AddCourt                = lazy(() => import('../features/court-management/pages/AddCourt'));
// const CourtRegistrations      = lazy(() => import('../features/court-management/pages/CourtRegistrations'));
// const SportList               = lazy(() => import('../features/sport-management/pages/SportList'));
// const CustomerList            = lazy(() => import('../features/user-management/pages/CustomerList'));
// const AddSport                = lazy(() => import('../features/sport-management/pages/AddSport'));
// const RefereeList             = lazy(() => import('../features/referee-management/pages/RefereeList'));
// const RefereeSelectTournament = lazy(() => import('../features/live-score-update/RefereeSelectTournament')); 
// const PaymentsList            = lazy(() => import('../features/payments/pages/PaymentsList'));
// const RolesPermissions        = lazy(() => import('../features/roles-permissions/pages/RolesPermissions'));
// const CommissionList          = lazy(() => import('../features/commission-management/CommissionList'));
// const RoleList                = lazy(() => import('../features/roles-permissions/pages/RoleList'));
// const UserList                = lazy(() => import('../features/roles-permissions/pages/UserList'));
// const PlayerList              = lazy(()=> import('../features/players-management/playerlist') );
// const PlayerRegistration      = lazy(() => import('../features/players-management/PlayerRegistration'));     // ← NEW
// const ManageRewards     = lazy(() => import('../features/rewards-management/rewards'));
// const AICoachAssistance = lazy(() => import('../features/ai-coach-assistance-management/AICoach'));

// export const publicRoutes = [
//     {
//         path     : '/login',
//         component: Login,
//     },
// ];

// export const protectedRoutes = [
//     // ── Dashboard ──────────────────────────────────────────────────────────
//     {
//         path     : '/',
//         component: Dashboard,
//         roles    : ['super-admin', 'admin'],
//     },
//     {
//         path     : '/dashboard',
//         component: Dashboard,
//         roles    : ['super-admin', 'admin'],
//     },

//     // ── Admin Management ───────────────────────────────────────────────────
//     {
//         path     : '/admin-management',
//         component: AdminList,
//         roles    : ['super-admin', 'admin'],
//     },
//     {
//         path     : '/admin-management/create',
//         component: CreateAdmin,
//         roles    : ['super-admin', 'admin'],
//     },

//     // ── Court Management ───────────────────────────────────────────────────
//     {
//         path     : '/court-management',
//         component: CourtList,
//         roles    : ['super-admin', 'admin','vendor'],
//     },
//     {
//         path     : '/court-management/add',
//         component: AddCourt,
//         roles    : ['super-admin', 'admin','vendor'],
//     },
//     {
//         path     : '/court-management/:id/registrations',
//         component: CourtRegistrations,
//         roles    : ['super-admin', 'admin','vendor'],
//     },

//     // ── Tournament Management ──────────────────────────────────────────────
//     {
//         path     : '/tournaments',
//         component: TournamentList,
//         roles    : ['super-admin', 'admin','vendor'],
//     },
//     {
//         path     : '/tournaments/create',
//         component: CreateTournament,
//         roles    : ['super-admin', 'admin','vendor'],
//     },
//     {
//         path     : '/tournaments/:id',
//         component: TournamentDetails,
//         roles    : ['super-admin', 'admin','vendor'],
//     },
//     {
//         path     : '/tournaments/:id/registrations',
//         component: TournamentRegistrations,
//         roles    : ['super-admin', 'admin','vendor'],
//     },
//     {
//         path     : '/tournaments/:id/matches',
//         component: ViewMatches,
//         roles    : ['super-admin', 'admin','vendor'],
//     },
//     {
//         path     : '/tournaments/:id/schedule-matches',
//         component: ScheduleMatches,
//         roles    : ['super-admin', 'admin','vendor'],
//     },
//     {
//         path     : '/tournaments/:id/group-players',
//         component: GroupPlayers,
//         roles    : ['super-admin', 'admin','vendor'],
//     },

//     // ── Sports Management ──────────────────────────────────────────────────
//     {
//         path     : '/sports-management',
//         component: SportList,
//         roles    : ['super-admin', 'admin'],
//     },
//     {
//         path     : '/sports-management/add',
//         component: AddSport,
//         roles    : ['super-admin', 'admin'],
//     },

//     // ── Coach Management ───────────────────────────────────────────────────
//     {
//         path     : '/coach-management',
//         component: CoachList,
//         roles    : ['super-admin', 'admin','vendor'],
//     },
//     {
//         path     : '/coach-management/registrations',      // ← NEW
//         component: CoachRegistration,
//         roles    : ['super-admin', 'admin','vendor'],
//     },

//     // ── Player Management ───────────────────────────────────────────────────
//     {
//         path     : '/player-management',
//         component: PlayerList,
//         roles    : ['super-admin', 'admin','vendor'],
//     },
//     {
//         path     : '/player-management/registrations',     // ← NEW
//         component: PlayerRegistration,
//         roles    : ['super-admin', 'admin','vendor'],
//     },

//     // ── User Management ────────────────────────────────────────────────────
//     {
//         path     : '/user-management',
//         component: CustomerList,
//         roles    : ['super-admin', 'admin','vendor'],
//     },

//     // ── Referee Management (Admin view) ────────────────────────────────────
//     {
//         path     : '/referee-management',
//         component: RefereeList,
//         roles    : ['super-admin', 'admin','vendor'],
//     },

//     // ── Referee Portal (Referee role) ──────────────────────────────────────
//     {
//         path     : '/live-score-update',
//         component: RefereeSelectTournament,
//         roles    : ['referee','super-admin','admin'],
//     }, 

//     // ── Roles & Permissions ────────────────────────────────────────────────
//     {
//         path     : '/roles-permissions',
//         component: RolesPermissions,
//         roles    : ['super-admin', 'admin'],
//     },
//     {
//         path     : '/roles-list',
//         component: RoleList,
//         roles    : ['super-admin', 'admin'],
//     },
//     {
//         path     : '/user-list',
//         component: UserList,
//         roles    : ['super-admin', 'admin'],
//     },

//     // ── Payments & Revenue ─────────────────────────────────────────────────
//     {
//         path     : '/payments-revenue',
//         component: PaymentsList,
//         roles    : ['super-admin', 'admin'],
//     },
//     {
//         path     : '/commmission-management',
//         component: CommissionList,
//         roles    : ['super-admin', 'admin'],
//     },
//     {
//     path     : '/manage-rewards',
//     component: ManageRewards,
//     roles    : ['super-admin', 'admin'],
//     },
//     {
//         path     : '/ai-coach-assistance',
//         component: AICoachAssistance,
//         roles    : ['super-admin', 'admin'],
//     },
// ];
import { lazy } from 'react';

// Lazy load components
const Dashboard = lazy(() => import('../features/dashboard/Dashboard'));
const Login = lazy(() => import('../features/auth/pages/Login'));
const AdminList = lazy(() => import('../features/admin-management/pages/AdminList'));
const CreateAdmin = lazy(() => import('../features/admin-management/pages/CreateAdmin'));
const TournamentList = lazy(() => import('../features/tournament-management/pages/TournamentList'));
const TournamentDetails = lazy(() => import('../features/tournament-management/pages/TournamentDetails'));
const CreateTournament = lazy(() => import('../features/tournament-management/pages/CreateTournament'));
const TournamentRegistrations = lazy(() => import('../features/tournament-management/pages/TournamentRegistrations'));
const ViewMatches = lazy(() => import('../features/tournament-management/pages/ViewMatches'));
const ScheduleMatches = lazy(() => import('../features/tournament-management/pages/ScheduleMatches'));
const GroupPlayers = lazy(() => import('../features/tournament-management/pages/GroupPlayers'));
const CoachList = lazy(() => import('../features/coach-management/pages/CoachList'));
const CoachRegistration = lazy(() => import('../features/coach-management/pages/CoachRegistration'));
const CourtList = lazy(() => import('../features/court-management/pages/CourtList'));
const AddCourt = lazy(() => import('../features/court-management/pages/AddCourt'));
const CourtRegistrations = lazy(() => import('../features/court-management/pages/CourtRegistrations'));
const SportList = lazy(() => import('../features/sport-management/pages/SportList'));
const CustomerList = lazy(() => import('../features/user-management/pages/CustomerList'));
const AddSport = lazy(() => import('../features/sport-management/pages/AddSport'));
const RefereeList = lazy(() => import('../features/referee-management/pages/RefereeList'));
const RefereeSelectTournament = lazy(() => import('../features/live-score-update/RefereeSelectTournament'));
const PaymentsList = lazy(() => import('../features/payments/pages/PaymentsList'));
const RolesPermissions = lazy(() => import('../features/roles-permissions/pages/RolesPermissions'));
const CommissionList = lazy(() => import('../features/commission-management/CommissionList'));
const RoleList = lazy(() => import('../features/roles-permissions/pages/RoleList'));
const UserList = lazy(() => import('../features/roles-permissions/pages/UserList'));
const PlayerList = lazy(() => import('../features/players-management/playerlist'));
const PlayerRegistration = lazy(() => import('../features/players-management/PlayerRegistration'));
const ManageRewards = lazy(() => import('../features/rewards-management/rewards'));
const AICoachAssistance = lazy(() => import('../features/ai-coach-assistance-management/AICoach'));
const CoachViewRegistration = lazy(() => import('../features/coach-management/pages/CoachRegistration'));
const CoachMonthlyRegistration = lazy(() => import('../features/coach-management/pages/MonthlyRegistration'));

const AdminLogin = lazy(() => import('../features/auth/pages/AdminLogin'));

const ForgotPassword = lazy(() => import('../features/auth/pages/ForgotPassword'));
const ResetPassword = lazy(() => import('../features/auth/pages/ResetPassword'));
const NotificationsPage = lazy(() => import('../features/notifcations/NotificationsPage'));
const ContactSupport = lazy(() => import('../features/contact-support/contact_support'));


export const publicRoutes = [
  {
    path: '/login',
    component: Login,
  },
   {
    path: '/admin/login',
    component: AdminLogin,
  },
   { path: '/forgot-password', component: ForgotPassword }, // add this
  { path: '/reset-password', component: ResetPassword },   // add this
];

export const protectedRoutes = [
  {
    path: '/',
    component: Dashboard,
    permission: 'dashboard_view',
    activePaths: ['/', '/dashboard'],
  },
  {
    path: '/dashboard',
    component: Dashboard,
    permission: 'dashboard_view',
    activePaths: ['/', '/dashboard'],
  },

  {
    path: '/admin-management',
    component: AdminList,
    permission: 'admin_management_view',
    activePaths: ['/admin-management'],
  },
  {
    path: '/admin-management/create',
    component: CreateAdmin,
    permission: 'admin_management_create',
    activePaths: ['/admin-management', '/admin-management/create'],
  },

  {
    path: '/court-management',
    component: CourtList,
    permission: 'court_management_view',
    activePaths: ['/court-management'],
  },
  {
    path: '/court-management/add',
    component: AddCourt,
    permission: 'court_management_create',
    activePaths: ['/court-management', '/court-management/add'],
  },
  {
    path: '/court-management/:id/registrations',
    component: CourtRegistrations,
    permission: 'court_management_view',
    activePaths: ['/court-management'],
  },

  {
    path: '/tournaments',
    component: TournamentList,
    permission: 'tournament_management_view',
    activePaths: ['/tournaments'],
  },
  {
    path: '/tournaments/create',
    component: CreateTournament,
    permission: 'tournament_management_create',
    activePaths: ['/tournaments', '/tournaments/create'],
  },
  {
    path: '/tournaments/:id',
    component: TournamentDetails,
    permission: 'tournament_management_view',
    activePaths: ['/tournaments'],
  },
  {
    path: '/tournaments/:id/registrations',
    component: TournamentRegistrations,
    permission: 'tournament_management_view',
    activePaths: ['/tournaments'],
  },
  {
    path: '/tournaments/:id/matches',
    component: ViewMatches,
    permission: 'tournament_management_view',
    activePaths: ['/tournaments'],
  },
  {
    path: '/tournaments/:id/schedule-matches',
    component: ScheduleMatches,
    permission: 'tournament_management_update',
    activePaths: ['/tournaments'],
  },
  {
    path: '/tournaments/:id/group-players',
    component: GroupPlayers,
    permission: 'tournament_management_update',
    activePaths: ['/tournaments'],
  },

  {
    path: '/sports-management',
    component: SportList,
    permission: 'sports_management_view',
    activePaths: ['/sports-management'],
  },
  {
    path: '/sports-management/add',
    component: AddSport,
    permission: 'sports_management_create',
    activePaths: ['/sports-management', '/sports-management/add'],
  },

  {
    path: '/coach-management',
    component: CoachList,
    permission: 'coach_management_view',
    activePaths: ['/coach-management'],
  },
  {
    path: '/coach-management/registrations',
    component: CoachRegistration,
    permission: 'coach_management_view',
    activePaths: ['/coach-management'],
  },
   {
    path: '/coach/registrations',
    component: CoachViewRegistration,
    permission: null, // role-gated instead of permission-gated
    role: 'coach',
    activePaths: ['/coach/registrations'],
  },
  {
    path: '/coach/monthly-registration',
    component: CoachMonthlyRegistration,
    permission: null,
    role: 'coach',
    activePaths: ['/coach/monthly-registration'],
  },

  {
    path: '/player-management',
    component: PlayerList,
    permission: 'player_management_view',
    activePaths: ['/player-management'],
  },
  {
    path: '/player-management/registrations',
    component: PlayerRegistration,
    permission: 'player_management_create',
    activePaths: ['/player-management'],
  },

  {
    path: '/user-management',
    component: CustomerList,
    permission: 'customer_management_view',
    activePaths: ['/user-management'],
  },

  {
    path: '/referee-management',
    component: RefereeList,
    permission: 'referee_management_view',
    activePaths: ['/referee-management'],
  },

    {
    path: '/contact-support',
    component: ContactSupport,
    permission: 'contact_support_view',
    activePaths: ['/contact-support'],
  },

  {
    path: '/live-score-update',
    component: RefereeSelectTournament,
    permission: 'live_score_update_view',
    activePaths: ['/live-score-update'],
  },

  {
    path: '/roles-permissions',
    component: RolesPermissions,
    permission: 'page_access_manage',
    activePaths: ['/roles-permissions'],
  },
  {
    path: '/roles-list',
    component: RoleList,
    permission: 'roles_view',
    activePaths: ['/roles-list'],
  },
  {
    path: '/user-list',
    component: UserList,
    permission: 'page_access_manage',
    activePaths: ['/user-list'],
  },

  {
    path: '/payments-revenue',
    component: PaymentsList,
    permission: 'payments_revenue_view',
    activePaths: ['/payments-revenue'],
  },

  {
    path: '/commmission-management',
    component: CommissionList,
    permission: 'commission_management_view',
    activePaths: ['/commmission-management'],
  },

  {
    path: '/manage-rewards',
    component: ManageRewards,
    permission: 'manage_rewards_view',
    activePaths: ['/manage-rewards'],
  },
  {
    path: '/ai-coach-assistance',
    component: AICoachAssistance,
    permission: 'ai_coach_assistance_view',
    activePaths: ['/ai-coach-assistance'],
  },

  {
  path: '/notifications',
  component: NotificationsPage,
  permission: null,
  activePaths: ['/notifications'],
},
];